import { Injectable } from '@angular/core';
import { PdfExportDomain } from '@mode/shared/contract-common';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { reportRunCache } from '@mode/shared/data-access-webapp';
import { ApiService, getEmbedded, getForm } from '@mode/shared/util-halogen';
import { PdfExport } from 'libs/shared/contract-common/src/lib/pdf-export/pdf-export.types';
import { from, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { toPdfExport } from './pdf-export-data-mappers';
import { PdfExportResource } from './pdf-export-response.types';

@Injectable({
  providedIn: 'root',
})
export class PdfExportClientService {
  constructor(private apiService: ApiService) {}

  getPdfExport(reportRunToken: string, reload: boolean) {
    const cachedRun = reportRunCache.get(reportRunToken);
    if (cachedRun) {
      return from(this.apiService.getResource<PdfExportResource>(cachedRun, 'pdf_export', { reload })).pipe(
        map((response) => {
          return toPdfExport(response);
        })
      );
    }

    return throwError(new Error('report run not found'));
  }

  postPdfExport(reportRunToken: string) {
    const cached = reportRunCache.get(reportRunToken);

    if (cached) {
      const pdf_form = getEmbedded(cached, 'new_pdf_export');
      if (pdf_form) {
        const pdf_form_form = getForm(pdf_form, 'create');
        if (pdf_form_form) {
          return from(this.apiService.submit<PdfExportResource>(pdf_form_form, {})).pipe(
            map((response) => {
              return toPdfExport(response);
            }),
            catchError((response) =>
              of<PdfExport>({
                state: PdfExportDomain.PdfExportState.Failed,
                filename: '',
                error: new Error('API Failure'),
              })
            )
          );
        }
      }
    }

    return throwError(() => new Error('report run not found'));
  }
}
